<template>
  <div class="case-creation__step case-creation__billing-information">
    <el-row>
      <el-col :span="24">
        <div class="case-creation__card">
          <div class="case-creation__heading edit-view">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-billing-info.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Billing Information</h3>
            </div>
            <div class="editBilling" v-if="!this.editForm && !isBillingUser">
              <el-button class="editButton mr-5" @click="goToEditForm">
                <span> Edit</span>
              </el-button>
            </div>
          </div>
          <div
            class="case-creation__billing-information__body"
            v-if="this.editForm"
          >
            <div
              class="case-creation__tabs billing-information-tabs"
              v-loading="loading"
            >
              <el-tabs v-model="activeName" @tab-click="updateSelectedTabQuery">
                <el-tab-pane name="first">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasError }"
                      >primary insurance</span
                    >
                  </template>
                  <PrimaryInsurance
                    v-if="activeName === 'first' && showInsuranceDob"
                    :primaryInsurance="primaryInsuranceForm"
                    :refreshDob="refreshPatientDob"
                    :parentRefs="$refs"
                    ref="primaryInsuranceForm"
                  ></PrimaryInsurance>
                </el-tab-pane>
                <el-tab-pane name="second">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasSecondaryErrors }"
                      >Secondary Insurance</span
                    >
                  </template>
                  <SecondaryInsurance
                    v-if="activeName === 'second' && showInsuranceDob"
                    :secondaryInsurance="secondaryInsuranceForm"
                    ref="secondaryInsuranceForm"
                    :parentRefs="$refs"
                    :refreshDob="true"
                    :patientInfo="patientDetails"
                  ></SecondaryInsurance>
                </el-tab-pane>
                <el-tab-pane name="third">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasTertiaryErrors }"
                      >Tertiary Insurance</span
                    >
                  </template>

                  <TertiaryInsuranceForm
                    v-if="activeName === 'third' && showInsuranceDob"
                    :tertiaryInsurance="tertiaryInsuranceForm"
                    ref="tertiaryInsuranceForm"
                    :parentRefs="$refs"
                    :refreshDob="true"
                  ></TertiaryInsuranceForm>
                </el-tab-pane>
                <el-tab-pane name="fourth">
                  <template #label>
                    <span
                      class="inactive-tabs"
                      :class="{ 'active-tabs': hasGuarantorErrors }"
                      >Guarantor</span
                    >
                  </template>

                  <GuarantorInsurance
                    v-if="activeName === 'fourth' && showInsuranceDob"
                    :guarantorInsurance="guarantorInsuranceForm"
                    ref="guarantorInsuranceForm"
                    :parentRefs="$refs"
                  ></GuarantorInsurance>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="case-creation__actions">
              <ul class="list">
                <li>
                  <el-button class="btn cancel-button" @click="saveInsurance"
                    >Save</el-button
                  >
                </li>
                <li>
                  <el-button class="btn save-button mr-20" @click="cancelEdit"
                    >Cancel</el-button
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="case-creation__body bill pt-5" v-else>
            <div
              v-if="insuranceSwapAction"
              class="ins-swap-banner"
              :class="{ 'is-swapped': insuranceSwapAction === 'undo' }"
            >
              <div class="ins-swap-icon">⇅</div>
              <div class="ins-swap-text">
                <div class="ins-swap-title">
                  <template v-if="insuranceSwapAction === 'swap'">
                    Secondary insurance is {{ orderInsurance.secondaryPayor }}
                  </template>
                  <template v-else>Insurance swapped manually</template>
                </div>
                <div class="ins-swap-sub">
                  <template v-if="insuranceSwapAction === 'swap'">
                    Swap to make {{ orderInsurance.secondaryPayor }} primary and {{ orderInsurance.primaryPayor }} secondary.
                    Accessioning is not blocked.
                  </template>
                  <template v-else>
                    {{ orderInsurance.primaryPayor }} is primary, {{ orderInsurance.secondaryPayor }} is secondary.
                    <span v-if="getCaseInformation.insurance_swap_details?.swapped_by">
                      Swapped by {{ getCaseInformation.insurance_swap_details.swapped_by }}
                      <template v-if="getCaseInformation.insurance_swap_details.swapped_at">
                        on {{ formatSwapDate(getCaseInformation.insurance_swap_details.swapped_at) }}
                      </template>.
                    </span>
                    Automatic insurance replacement is turned off for this order.
                  </template>
                </div>
              </div>
              <el-button
                class="ins-swap-btn"
                :class="{ 'is-undo': insuranceSwapAction === 'undo' }"
                :loading="insuranceSwapping"
                @click="onSwapInsurance"
              >
                {{ insuranceSwapAction === 'swap' ? 'Swap to Primary' : 'Swap Back' }}
              </el-button>
            </div>
            <div class="case-creation__tabs billing-information-tabs">
              <el-tabs v-model="activeName">
                <el-tab-pane label="PRIMARY INSURANCE" name="first">
                  <div id="primary-insurance" v-if="activeName === 'first'">
                    <div class="primary-insurance-view">
                      <div class="step-inner-navbar"></div>

                      <div class="step-inner-content">
                        <div class="vue-form">
                          <el-form>
                            <el-row :gutter="15">
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Relationship</h4>
                                  <p
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.relationship
                                    "
                                  >
                                    {{ getBillingInformation.relationship }}
                                  </p>
                                  <p class="value" v-else>--</p>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Plan Type</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.plan_type
                                    "
                                  >
                                    {{ getBillingInformation.plan_type }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">First Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.first_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.primary_insurance
                                          .first_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Middle Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.middle_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.primary_insurance
                                          .middle_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> --</span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Last Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.last_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.primary_insurance.last_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> --</span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Gender</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.gender
                                    "
                                  >
                                    {{ getBillingInformation.gender }}
                                  </span>
                                  <span class="value" v-else> --</span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Date of Birth</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.date_of_birth
                                    "
                                  >
                                    {{
                                      formatDate(
                                        getBillingInformation.date_of_birth
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> --</span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.payor
                                    "
                                  >
                                    {{ getBillingInformation.payor }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Carrier Code</h4>
                                  <span
                                    class="value"
                                    v-if="getBillingInformation"
                                  >
                                    {{
                                      getCaseInformation.billing_info.insurance
                                        .primary_insurance
                                        .insurance_carrier_code
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Policy No</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.policy_id
                                    "
                                  >
                                    {{ getBillingInformation.policy_id }}
                                  </span>
                                  <span class="value" v-else> --</span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Group#</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.group
                                    "
                                  >
                                    {{ getBillingInformation.group }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 1</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.address_line_1
                                    "
                                  >
                                    {{ getBillingInformation.address_line_1 }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 2</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.address_line_2
                                    "
                                  >
                                    {{ getBillingInformation.address_line_2 }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Zip</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.zip
                                    "
                                  >
                                    {{ getBillingInformation.zip }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">State</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.state
                                    "
                                  >
                                    {{ getBillingInformation.state }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">City</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getBillingInformation &&
                                      getBillingInformation.city
                                    "
                                  >
                                    {{ getBillingInformation.city }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                            </el-row>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="SECONDARY INSURANCE" name="second">
                  <div id="secondary-insurance" v-if="activeName === 'second'">
                    <div class="secondary-insurance-view">
                      <div class="step-inner-navbar"></div>

                      <div class="step-inner-content">
                        <div class="vue-form">
                          <el-form>
                            <el-row :gutter="15">
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Relationship</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.relationship
                                    "
                                  >
                                    {{ getSecondaryInsurance.relationship }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Plan Type</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.plan_type
                                    "
                                  >
                                    {{ getSecondaryInsurance.plan_type }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">First Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.first_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.secondary_insurance
                                          .first_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Middle Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.middle_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.secondary_insurance
                                          .middle_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Last Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.last_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.secondary_insurance
                                          .last_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Gender</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.gender
                                    "
                                  >
                                    {{ getSecondaryInsurance.gender }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Date of Birth</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.date_of_birth
                                    "
                                  >
                                    {{
                                      formatDate(
                                        getSecondaryInsurance.date_of_birth
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.payor
                                    "
                                  >
                                    {{ getSecondaryInsurance.payor }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Carrier Code</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.insurance_carrier_code
                                    "
                                  >
                                    {{
                                      getCaseInformation.billing_info.insurance
                                        .secondary_insurance
                                        .insurance_carrier_code
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Policy No</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.policy_id
                                    "
                                  >
                                    {{ getSecondaryInsurance.policy_id }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Group#</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.group
                                    "
                                  >
                                    {{ getSecondaryInsurance.group }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 1</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.address_line_1
                                    "
                                  >
                                    {{ getSecondaryInsurance.address_line_1 }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 2</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.address_line_2
                                    "
                                  >
                                    {{ getSecondaryInsurance.address_line_2 }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Zip</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.zip
                                    "
                                  >
                                    {{ getSecondaryInsurance.zip }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">State</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.state
                                    "
                                  >
                                    {{ getSecondaryInsurance.state }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">City</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getSecondaryInsurance &&
                                      getSecondaryInsurance.city
                                    "
                                  >
                                    {{ getSecondaryInsurance.city }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                            </el-row>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="TERTIARY INSURANCE" name="third">
                  <div id="tertiary-insurance" v-if="activeName === 'third'">
                    <div class="tertiary-insurance-view">
                      <div class="step-inner-navbar"></div>

                      <div class="step-inner-content">
                        <div class="vue-form">
                          <el-form>
                            <el-row :gutter="15">
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Relationship</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.relationship
                                    "
                                  >
                                    {{ getTertiaryInsurance.relationship }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Plan Type</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.plan_type
                                    "
                                  >
                                    {{ getTertiaryInsurance.plan_type }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">First Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.first_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.tertiary_insurance
                                          .first_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Middle Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.middle_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.tertiary_insurance
                                          .middle_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Last Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.last_name
                                    "
                                  >
                                    {{
                                      convertToUppercase(
                                        getCaseInformation.billing_info
                                          .insurance.tertiary_insurance
                                          .last_name
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Gender</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.gender
                                    "
                                  >
                                    {{ getTertiaryInsurance.gender }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Date of Birth</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.date_of_birth
                                    "
                                  >
                                    {{
                                      formatDate(
                                        getTertiaryInsurance.date_of_birth
                                      )
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Name</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.payor
                                    "
                                  >
                                    {{ getTertiaryInsurance.payor }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Insurance Carrier Code</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.insurance_carrier_code
                                    "
                                  >
                                    {{
                                      getCaseInformation.billing_info.insurance
                                        .tertiary_insurance
                                        .insurance_carrier_code
                                    }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="3" :sm="6" :xs="6">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Policy No</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.policy_id
                                    "
                                  >
                                    {{ getTertiaryInsurance.policy_id }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Group#</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.group
                                    "
                                  >
                                    {{ getTertiaryInsurance.group }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="4" :sm="10" :xs="10">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 1</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.address_line_1
                                    "
                                  >
                                    {{ getTertiaryInsurance.address_line_1 }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Address Line 2</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.address_line_2
                                    "
                                  >
                                    {{ getTertiaryInsurance.address_line_2 }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">Zip</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.zip
                                    "
                                  >
                                    {{ getTertiaryInsurance.zip }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>

                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">State</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.state
                                    "
                                  >
                                    {{ getTertiaryInsurance.state }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                              <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                                <div
                                  class="case-creation__input input-value view-cases"
                                >
                                  <h4 class="name">City</h4>
                                  <span
                                    class="value"
                                    v-if="
                                      getTertiaryInsurance &&
                                      getTertiaryInsurance.city
                                    "
                                  >
                                    {{ getTertiaryInsurance.city }}
                                  </span>
                                  <span class="value" v-else> -- </span>
                                </div>
                              </el-col>
                            </el-row>
                          </el-form>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="GUARANTOR INSURANCE" name="fourth">
                  <div id="guarantorForm-view" v-if="activeName === 'fourth'">
                    <div class="step-inner-navbar"></div>

                    <div class="step-inner-content">
                      <div class="vue-form">
                        <el-form>
                          <el-row :gutter="25">
                            <el-col :xl="4" :lg="3" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Relationship</h4>
                                <span
                                  class="value"
                                  v-if="
                                    getGuarantor && getGuarantor.relationship
                                  "
                                >
                                  {{ getGuarantor.relationship }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">First Name</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    convertToUppercase(
                                      getCaseInformation.billing_info.insurance
                                        .guarantor.first_name
                                    )
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Middle Name</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    convertToUppercase(
                                      getCaseInformation.billing_info.insurance
                                        .guarantor.middle_name
                                    )
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Last Name</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    convertToUppercase(
                                      getCaseInformation.billing_info.insurance
                                        .guarantor.last_name
                                    )
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="3" :md="3" :sm="6" :xs="6">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Gender</h4>
                                <span class="value" v-if="getGuarantor">
                                  {{
                                    getCaseInformation.billing_info.insurance
                                      .guarantor.gender
                                  }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>

                            <el-col :xl="4" :lg="6" :md="4" :sm="10" :xs="10">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Address Line 1</h4>
                                <span
                                  class="value"
                                  v-if="
                                    getGuarantor && getGuarantor.address_line_1
                                  "
                                >
                                  {{ getGuarantor.address_line_1 }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="4" :lg="7" :md="4" :sm="10" :xs="10">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Address Line 2</h4>
                                <span
                                  class="value"
                                  v-if="
                                    getGuarantor && getGuarantor.address_line_2
                                  "
                                >
                                  {{ getGuarantor.address_line_2 }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">Zip</h4>
                                <span
                                  class="value"
                                  v-if="getGuarantor && getGuarantor.zip"
                                >
                                  {{ getGuarantor.zip }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">State</h4>
                                <span
                                  class="value"
                                  v-if="getGuarantor && getGuarantor.state"
                                >
                                  {{ getGuarantor.state }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                            <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                              <div
                                class="case-creation__input input-value view-cases"
                              >
                                <h4 class="name">City</h4>
                                <span
                                  class="value"
                                  v-if="getGuarantor && getGuarantor.city"
                                >
                                  {{ getGuarantor.city }}
                                </span>
                                <span class="value" v-else> -- </span>
                              </div>
                            </el-col>
                          </el-row>
                        </el-form>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <ResonForChange
    v-if="takeReasonDialog"
    v-on:close="takeReasonDialog = false"
    v-on:reasonSubmit="updateCase"
  ></ResonForChange>
</template>
<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
const ResonForChange = defineAsyncComponent(() =>
  import("@/components/misc/ResonForChange")
);
const PrimaryInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/PrimaryInsurance")
);
const SecondaryInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/SecondaryInsurance")
);
const TertiaryInsuranceForm = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/TertiaryInsurance")
);
const GuarantorInsurance = defineAsyncComponent(() =>
  import("@/components/orders/billingInfo/forms/GuarantorInsurance")
);
import InsuranceHelper from "@/mixins/InsuranceHelper";
import { ElMessageBox } from "element-plus";
import { getInsuranceSwapAction, getOrderInsurance } from "@/helpers/insuranceSwap";

export default {
  mixins: [UserPermissionsHelper, InsuranceHelper],
  components: {
    ResonForChange,
    PrimaryInsurance,
    SecondaryInsurance,
    TertiaryInsuranceForm,
    GuarantorInsurance,
  },
  data() {
    return {
      activeName: "first",
      loading: false,
      takeReasonDialog: false,
      editForm: false,
      showInsuranceDob: false,
      primaryInsuranceForm: {},
      secondaryInsuranceForm: {},
      tertiaryInsuranceForm: {},
      guarantorInsuranceForm: {},
      patientDetails: "",
      orderId: "",
      signatureInformation: {
        patient_signature: false,
        physician_signature: false,
        guardian_signature: false,
      },
      patient_sign: "",
      physician_sign: "",
      guardian_sign: "",
      physician_notes: "",
      insuranceSwapping: false,
    };
  },
  computed: {
    insuranceSwapAction() {
      return getInsuranceSwapAction(this.getCaseInformation);
    },
    orderInsurance() {
      return getOrderInsurance(this.getCaseInformation);
    },

    ...mapGetters("orders", [
      "getCaseInformation",
      "getDeleteOrderBillingInfoStatus",
      "getCaseInformationSaveStatus",
    ]),
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("errors", ["getErrors", "getError"]),

    isOrderCompleted() {
      if (!this.getCaseInformation) {
        return false;
      }
      return this.getCaseInformation.status === "COMPLETE";
    },
    hasAllowedCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.length
        ) {
          const cases = this.getCaseInformation.case_types;
          const casetypes = this.getAuthenticatedUser.allowed_case_types;

          if (cases.every((item) => casetypes.includes(item))) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    getBillingInformation() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation).length > 0 &&
        this.getCaseInformation.billing_info &&
        this.getCaseInformation.billing_info.insurance
      ) {
        return this.getCaseInformation.billing_info.insurance.primary_insurance;
      }
      return null;
    },
    getSecondaryInsurance() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation).length > 0 &&
        this.getCaseInformation.billing_info &&
        this.getCaseInformation.billing_info.insurance
      ) {
        return this.getCaseInformation.billing_info.insurance
          .secondary_insurance;
      }
      return null;
    },
    getTertiaryInsurance() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation).length > 0 &&
        this.getCaseInformation.billing_info &&
        this.getCaseInformation.billing_info.insurance
      ) {
        return this.getCaseInformation.billing_info.insurance
          .tertiary_insurance;
      }
      return null;
    },
    getGuarantor() {
      if (
        this.getCaseInformation &&
        Object.keys(this.getCaseInformation).length > 0 &&
        this.getCaseInformation.billing_info &&
        this.getCaseInformation.billing_info.insurance
      ) {
        return this.getCaseInformation.billing_info.insurance.guarantor;
      }
      return null;
    },
    isToxicCaseType() {
      if (
        this.getCaseInformation &&
        this.getCaseInformation.case_types &&
        this.getCaseInformation.case_types.length &&
        this.getCaseInformation.case_types.includes("TOXICOLOGY")
      ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    formatSwapDate(value) {
      return new Date(value).toLocaleString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async onSwapInsurance() {
      const isUndo = this.insuranceSwapAction === "undo";
      const { primaryPayor, secondaryPayor } = this.orderInsurance;
      try {
        await ElMessageBox.confirm(
          isUndo
            ? `Swap back so ${secondaryPayor} is primary and ${primaryPayor} is secondary?`
            : `Make ${secondaryPayor} the primary insurance and move ${primaryPayor} to secondary?`,
          isUndo ? "Swap insurance back" : "Swap insurance",
          { confirmButtonText: isUndo ? "Swap Back" : "Swap", cancelButtonText: "Cancel", type: "warning" }
        );
      } catch (cancelled) {
        return;
      }

      this.insuranceSwapping = true;
      try {
        const result = await this.$store.dispatch("orders/swapOrderInsurance", {
          order_id: this.getCaseInformation._id,
        });
        if (result?.success) {
          successNotification(result.message);
          await this.refreshOrderInformation();
        } else {
          errorNotification(result?.message || "Failed to swap insurance");
        }
      } finally {
        this.insuranceSwapping = false;
      }
    },
    async refreshOrderInformation() {
      await this.$store.dispatch("orders/fetchCaseInformation", {
        order_id: this.$route.params.order_id,
        isOldOrder: this.$route.query?.isOldOrder === "true",
      });
    },

    hasError() {
      if (this.getErrors && Object.keys(this.getErrors).length) {
        let errorsValues = Object.keys(this.getErrors);
        for (let i = 0; i < errorsValues.length; i++) {
          if (
            errorsValues[i].indexOf(
              "billing_info.insurance.primary_insurance"
            ) !== -1
          ) {
            return true;
          }
        }
      }
      return false;
    },
    deleteReason() {
      this.takeReasonDialog = true;
    },
    goToEditForm() {
      this.showInsuranceDob = true;

      this.editForm = true;
    },
    cancelEdit() {
      this.editForm = false;
      this.showInsuranceDob = false;
    },
    async fetchCaseInformation() {
      try {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.physician_notes
        ) {
          this.physician_notes = this.getCaseInformation.physician_notes;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.signature_settings
        ) {
          this.signatureInformation =
            this.getCaseInformation.signature_settings;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.signature_settings &&
          this.getCaseInformation.signature_settings.patient_sign
        ) {
          this.patient_sign =
            this.getCaseInformation.signature_settings.patient_sign;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.signature_settings &&
          this.getCaseInformation.signature_settings.physician_sign
        ) {
          this.physician_sign =
            this.getCaseInformation.signature_settings.physician_sign;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.signature_settings &&
          this.getCaseInformation.signature_settings.guardian_sign
        ) {
          this.guardian_sign =
            this.getCaseInformation.signature_settings.guardian_sign;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.billing_info &&
          this.getCaseInformation.billing_info.insurance &&
          this.getCaseInformation.billing_info.insurance.primary_insurance
        ) {
          this.primaryInsuranceForm = this.setInsuranceDataFromBackendData(
            this.getCaseInformation.billing_info.insurance.primary_insurance
          );
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.billing_info &&
          this.getCaseInformation.billing_info.insurance &&
          this.getCaseInformation.billing_info.insurance.secondary_insurance
        ) {
          this.secondaryInsuranceForm = this.setInsuranceDataFromBackendData(
            this.getCaseInformation.billing_info.insurance.secondary_insurance
          );
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.billing_info &&
          this.getCaseInformation.billing_info.insurance &&
          this.getCaseInformation.billing_info.insurance.tertiary_insurance
        ) {
          this.tertiaryInsuranceForm = this.setInsuranceDataFromBackendData(
            this.getCaseInformation.billing_info.insurance.tertiary_insurance
          );
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.billing_info &&
          this.getCaseInformation.billing_info.insurance &&
          this.getCaseInformation.billing_info.insurance.guarantor
        ) {
          this.guarantorInsuranceForm =
            this.getCaseInformation.billing_info.insurance.guarantor;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    prepareRequestBody() {
      return {
        case_types: this.getCaseInformation.case_types || [],
        lab: this.getCaseInformation.lab,
        ordering_date: this.getCaseInformation.ordering_date,
        temperature: this.getCaseInformation.temperature,

        collection_date: this.getCaseInformation.collection_date,
        hospital: this.getCaseInformation.hospital
          ? this.getCaseInformation.hospital._id
          : null,
        icd_10_codes: this.getCaseInformation.icd_10_codes || [],
        ordering_physician: this.getCaseInformation.ordering_physician._id,
        referring_physician:
          this.getCaseInformation.referring_physician &&
          this.getCaseInformation.referring_physician._id
            ? this.getCaseInformation.referring_physician._id
            : null,
        hospital_branch: this.getCaseInformation.hospital_branch
          ? this.getCaseInformation.hospital_branch._id
          : null,
        billing_type: this.getCaseInformation.billing_type,
        specimen_collector: this.getCaseInformation.specimen_collector,
        additional_fax: this.getCaseInformation.additional_fax || [],
        order_id: this.getCaseInformation.order_id,
        sample_types: this.getCaseInformation.sample_types.map(
          (sampleType) => ({
            sample_types: sampleType.sample_types,

            case_type: sampleType.case_type,
          })
        ),
        additional_fax_requisite:
          this.getCaseInformation.additional_fax_requisite,

        patient_info: {
          first_name: this.getCaseInformation.patient_info.first_name,
          last_name: this.getCaseInformation.patient_info.last_name,
          gender: this.getCaseInformation.patient_info.gender,
          date_of_birth: this.getCaseInformation.patient_info.date_of_birth,
          home_phone: this.getCaseInformation.patient_info.home_phone,
          address_line_1: this.getCaseInformation.patient_info.address_line_1,
          address_line_2: this.getCaseInformation.patient_info.address_line_2,
          city: this.getCaseInformation.patient_info.city,
          state: this.getCaseInformation.patient_info.state,
          zip: this.getCaseInformation.patient_info.zip,
          hospital: this.getCaseInformation.patient_info.hospital,
        },
        tests_info:
          this.getCaseInformation && this.getCaseInformation.tests_info
            ? this.getCaseInformation.tests_info.map((el) => el._id)
            : [],
        coriell_test_panels:
          this.getCaseInformation.coriell_test_panels &&
          this.getCaseInformation.coriell_test_panels.length
            ? this.getCaseInformation.coriell_test_panels
            : [],
        medication: this.getCaseInformation.medication || [],
        cpt_codes: this.getCaseInformation.cpt_codes || [],
        toxicology_ereq_form:
          this.getCaseInformation.toxicology_ereq_form || [],
        custom_test_profiles: this.getCaseInformation.custom_test_profiles,
        signature_settings: this.getCaseInformation.signature_settings,
      };
    },
    async saveInsurance() {
      this.takeReasonDialog = true;
    },
    async updateCase(reason) {
      this.updateNewCase(reason);
    },
    parseInsuranceForm(insuranceData) {
      let params = { ...insuranceData };

      // filtering the object
      // removing non entered values
      Object.keys(params).forEach((keyValue) => {
        if (!params[keyValue]) {
          delete params[keyValue];
        }
      });

      return params;
    },
    isObjectUpdated(original, updated) {
      const keys = Object.keys(original);

      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (original[key] !== updated[key]) {
          return true; // If any value is updated, return true
        }
      }

      return false; // If no value is updated, return false
    },
    formatDOB(dateString) {
      // Extracting the date part from the ISO date string
      if (!dateString) return "";
      return dateString.split("T")[0];
    },
    parseSignatureSettings() {
      let params = {};
      params = {
        patient_signature: this.signatureInformation.patient_signature,

        physician_signature: this.signatureInformation.physician_signature,

        guardian_signature: this.signatureInformation.guardian_signature,
      };
      if (this.patient_sign) {
        params.patient_sign = this.patient_sign;
      }
      if (this.physician_sign) {
        params.physician_sign = this.physician_sign;
      }
      if (this.guardian_sign) {
        params.guardian_sign = this.guardian_sign;
      }

      return params;
    },
    async updateNewCase(reason) {
      try {
        this.loading = true;
        let params = this.prepareRequestBody();
        const orderId = this.$route.params.order_id;
        params.order_id = orderId;
        params.data_update_reason = reason;
        let insurance = {};

        let primaryInsuranceFormDetails = this.$refs["primaryInsuranceForm"];
        if (primaryInsuranceFormDetails) {
          let primaryInsuranceFormData = this.parseInsuranceForm(
            primaryInsuranceFormDetails.getPrimaryInsuranceFormData()
          );

          if (Object.keys(primaryInsuranceFormData).length) {
            insurance.primary_insurance = primaryInsuranceFormData;
          }
          if (this.$route.params.order_id) {
            const newObj = { ...this.primaryInsuranceForm };
            if (
              newObj.hasOwnProperty("date_of_birth") &&
              newObj.date_of_birth !== ""
            ) {
              newObj.date_of_birth = this.formatDOB(
                this.primaryInsuranceForm.date_of_birth
              );
            }

            const isUpdated = this.isObjectUpdated(
              newObj,
              primaryInsuranceFormData
            );
            if (isUpdated) {
              params.allow_recheck_insurance = true;
            }
          }
        } else {
          if (this.primaryInsuranceForm) {
            if (Object.keys(this.primaryInsuranceForm).length) {
              insurance.primary_insurance = this.primaryInsuranceForm;
            }
          }
        }

        let secondaryInsuranceFormDetails =
          this.$refs["secondaryInsuranceForm"];
        if (secondaryInsuranceFormDetails) {
          let secondaryInsuranceFormData = this.parseInsuranceForm(
            secondaryInsuranceFormDetails.getSecondaryInsuranceFormData()
          );

          if (Object.keys(secondaryInsuranceFormData).length) {
            insurance.secondary_insurance = secondaryInsuranceFormData;
          }
        } else if (this.secondaryInsuranceForm) {
          if (Object.keys(this.secondaryInsuranceForm).length) {
            insurance.secondary_insurance = this.secondaryInsuranceForm;
          }
        }

        let tertiaryInsuranceFormDetails = this.$refs["tertiaryInsuranceForm"];
        if (tertiaryInsuranceFormDetails) {
          let tertiaryInsuranceFormData = this.parseInsuranceForm(
            tertiaryInsuranceFormDetails.getTertiaryInsuranceFormData()
          );

          if (Object.keys(tertiaryInsuranceFormData).length) {
            insurance.tertiary_insurance = tertiaryInsuranceFormData;
          }
        } else if (this.tertiaryInsuranceForm) {
          if (Object.keys(this.tertiaryInsuranceForm).length) {
            insurance.tertiary_insurance = this.tertiaryInsuranceForm;
          }
        }

        let guarantorInsuranceFormDetails =
          this.$refs["guarantorInsuranceForm"];
        if (guarantorInsuranceFormDetails) {
          let guarantorInsuranceFormData = this.parseInsuranceForm(
            guarantorInsuranceFormDetails.getGuarantorInsuranceFormData()
          );

          if (Object.keys(guarantorInsuranceFormData).length) {
            insurance.guarantor = guarantorInsuranceFormData;
          }
        } else if (this.guarantorInsuranceForm) {
          if (Object.keys(this.guarantorInsuranceForm).length) {
            insurance.guarantor = this.guarantorInsuranceForm;
          }
        }
        if (Object.keys(insurance).length > 0) {
          params.billing_info = { insurance: insurance };
        } else {
          params.billing_info = {};
        }
        if (this.physician_notes) {
          params.physician_notes = this.physician_notes;
        }
        if (
          this.getCaseInformation.toxicology_ereq_form &&
          this.getCaseInformation.toxicology_ereq_form.length &&
          this.isToxicCaseType
        ) {
          params.toxicology_ereq_form = this.toxicology_ereq_form;
        } else {
          params.toxicology_ereq_form = [];
        }
        if (
          this.getCaseInformation.is_fasting == true ||
          this.getCaseInformation.is_fasting == false
        ) {
          params.is_fasting = this.getCaseInformation.is_fasting;
        }
        if (
          this.getCaseInformation &&
          this.getCaseInformation.medical_necessities &&
          this.getCaseInformation.medical_necessities.length
        ) {
          params.medical_necessities =
            this.getCaseInformation.medical_necessities;
        }
        await this.$store.dispatch("orders/updateCase", params);

        if (this.getCaseInformationSaveStatus) {
          successNotification("Order Updated Successfully");
          window.location.reload();
        } else if (this.getErrors) {
          this.scrollToFirstError();
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification("Error while updating Case");
          }
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    updateSelectedTabQuery() {
      if (this.getCaseInformation && this.getCaseInformation.patient_info) {
        this.patientDetails = this.getCaseInformation.patient_info;
      }
      const primaryInfo = this.$refs["primaryInsuranceForm"];
      if (primaryInfo) {
        this.primaryInsuranceForm = this.parseInsuranceForm(
          primaryInfo.getPrimaryInsuranceFormData()
        );
      }
      const secondaryInfo = this.$refs["secondaryInsuranceForm"];
      if (secondaryInfo) {
        this.secondaryInsuranceForm = this.parseInsuranceForm(
          secondaryInfo.getSecondaryInsuranceFormData()
        );
      }
      const teritaryInfo = this.$refs["tertiaryInsuranceForm"];
      if (teritaryInfo) {
        this.tertiaryInsuranceForm = this.parseInsuranceForm(
          teritaryInfo.getTertiaryInsuranceFormData()
        );
      }
      const gaurantorInfo = this.$refs["guarantorInsuranceForm"];
      if (gaurantorInfo) {
        this.guarantorInsuranceForm = this.parseInsuranceForm(
          gaurantorInfo.getGuarantorInsuranceFormData()
        );
      }
    },
  },
};
</script>

<style lang="scss">
.case-creation__billing-information {
  .case-creation__body {
    padding: 0;
  }
  .el-tabs__content {
    padding: 0 20px;
  }
  .el-tabs__nav-scroll {
    padding: 0 20px;
  }
  .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .right-align {
    display: flex;
  }
  .delete-billing-info {
    margin-right: 20px;
    padding: 5px 0;

    button {
      background: #f24a55;
      min-height: 25px;
      border: none;

      padding: 5px 20px;
    }
  }
  .editBilling {
    button {
      display: flex;
      align-items: center;
      min-height: 30px;
      cursor: pointer;
      background: none;
      border: none;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      border: 1px solid #f24a55;
      background: #f24a55;
      border-radius: 4px;
      padding: 0px 10px;
    }
  }
}

.ins-swap-banner {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0 0 16px;
  padding: 12px 16px;
  border: 1px solid #c3c9eb;
  border-left: 4px solid #273480;
  border-radius: 10px;
  background: #eef0fa;

  &.is-swapped {
    border-color: #bbe5c8;
    border-left-color: #16a34a;
    background: #ecfdf3;

    .ins-swap-icon {
      background: #16a34a;
    }
  }
  .ins-swap-icon {
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #273480;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
  }
  .ins-swap-text {
    flex: 1;
    min-width: 0;
  }
  .ins-swap-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #1f2937;
  }
  .ins-swap-sub {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.45;
    color: #4b5563;
  }
  .el-button.ins-swap-btn {
    flex-shrink: 0;
    height: 36px;
    padding: 0 16px;
    border: 1px solid #273480;
    border-radius: 8px;
    background: #273480;
    color: #fff;
    font-size: 13px;
    font-weight: 600;

    &:hover,
    &:focus {
      background: #1e2966;
      border-color: #1e2966;
      color: #fff;
    }
    &.is-undo {
      background: #fff;
      color: #273480;

      &:hover,
      &:focus {
        background: #eef0fa;
        color: #273480;
      }
    }
  }
}
</style>
